var _excluded = ["isOpen", "onClose", "text", "textProps", "feedbackIndicator", "closeOnOverlayClick", "closeOnEsc", "sx"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as TQCModal from '../../../components/modal';
import { Spinner, Typography } from '../../../components';
import React from 'react';
import { useBreakpointValue } from '../../../components/media-query';
var ModalLoading = props => {
  var {
      isOpen,
      onClose,
      text,
      textProps,
      feedbackIndicator,
      closeOnOverlayClick = false,
      closeOnEsc = false,
      sx
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  var size = useBreakpointValue({
    base: 'full',
    md: '3xl'
  });
  var modalProps = _objectSpread({
    size
  }, rest);
  var feedbackIcon = React.useMemo(() => {
    if (feedbackIndicator) {
      return feedbackIndicator;
    }
    return /*#__PURE__*/React.createElement(Spinner, {
      color: "red",
      w: 5,
      h: 5
    });
  }, [feedbackIndicator]);
  return /*#__PURE__*/React.createElement(TQCModal.Modal, _extends({
    closeOnEsc: closeOnEsc,
    closeOnOverlayClick: closeOnOverlayClick,
    isOpen: isOpen,
    isCentered: true,
    onClose: onClose
  }, modalProps), /*#__PURE__*/React.createElement(TQCModal.ModalOverlay, null), /*#__PURE__*/React.createElement(TQCModal.ModalContent, {
    "aria-label": props['aria-label'],
    sx: sx
  }, /*#__PURE__*/React.createElement(TQCModal.ModalBody, {
    textAlign: "center"
  }, /*#__PURE__*/React.createElement(Typography, textProps, text), feedbackIcon)));
};
export { ModalLoading };